import moment from "moment";
import React from "react";
import { dateFormatter } from "../../../utils/Helper";
import MainComponentWrapper from "../../Common/MainComponentWrapper";

const CheckInCheckoutTabel = ({ details, isLoading, isError }) => {
  let tableData = [];

  for (let i = 0; i < details?.attendee?.checkInTime.length; i++) {
    let attendeeDetails = details?.attendee;
    tableData.push(
      <>
        <tr key={i}>
          <td>
            {attendeeDetails?.checkInTime[i]
              ? moment(attendeeDetails?.checkInTime[i])?.format("LLL")
              : "-"}
          </td>
          <td>
            {attendeeDetails?.checkOutTime[i]
              ? moment(attendeeDetails?.checkOutTime[i])?.format("LLL")
              : "-"}
          </td>
        </tr>
      </>
    );
  }

  return (
    <MainComponentWrapper errorInfo={isError} Loading={isLoading}>
      <div className="col-md-7">
        <div className="table-base responsive-table">
          {/* {console.log(tableData,"tab--------")} */}
          <table className="table table-borderless">
            <thead className="bg-E9EBEE">
              <tr>
                {/* <th scope="col">Date</th> */}
                <th scope="col" style={{ color: "#03a1fc" }}>
                  Check In Time
                </th>
                <th scope="col" style={{ color: "#fcbe03" }}>
                  Check Out Time
                </th>
              </tr>
            </thead>
            <tbody>{tableData}</tbody>
          </table>
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default CheckInCheckoutTabel;
